import { render, staticRenderFns } from "./priceSummary.vue?vue&type=template&id=c3fb4fb6"
import script from "./priceSummary.vue?vue&type=script&lang=js"
export * from "./priceSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports